import {
  FlightCheckInStatusEnum,
  HotelCheckInStatusEnum,
} from 'common/constants/enum';
import { Translate } from 'next-translate';

export const flightCheckInOptions = (t: Translate) => [
  {
    id: FlightCheckInStatusEnum.NotAvailable,
    label: t('enum:not_available'),
  },
  {
    id: FlightCheckInStatusEnum.NotCheckedIn,
    label: t('enum:not_checked_in'),
  },
  {
    id: FlightCheckInStatusEnum.CheckedIn,
    label: t('enum:checked_in'),
  },
  {
    id: FlightCheckInStatusEnum.SeatOk,
    label: t('enum:seat_ok'),
  },
];

export const hotelCheckInOptions = (t: Translate) => [
  {
    id: HotelCheckInStatusEnum.NotAvailable,
    label: t('enum:not_available'),
  },
  {
    id: HotelCheckInStatusEnum.NotCheckedIn,
    label: t('enum:not_checked_in'),
  },
  {
    id: HotelCheckInStatusEnum.CheckedIn,
    label: t('enum:checked_in'),
  },
];

// export default checkInOptions;
